var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("RelationChosenWidgetInput", {
        attrs: { value: _vm.listItem.data.where.id, entity: "places" },
        on: {
          "drag-change": _vm.change,
          input: function ($event) {
            return _vm.mixChangeListItemHandler({ id: $event }, "where")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }